import React, { FC, useState } from 'react'
import { Document, Page } from 'react-pdf';
import "../../../utils/pdfjs-init"
import HighlightMarker from './Highlighter';
import { usePDFAnnotationStore } from '../../../store/pdf-pin.store';
import { IsNullOrUndefined } from '../../../utils/null-check';

interface PDFViewerPropEntity {
    onLoadSuccess: () => void,
    pdfUrl: string;
    pageNumber: number;
    rotation?: number;
    scale?: number;
    pageRef: React.RefObject<HTMLDivElement> | null;
    isDragging?: boolean;
}

const PDFViewer: FC<PDFViewerPropEntity> = ({
    onLoadSuccess,
    pageNumber,
    pdfUrl,
    rotation = 0,
    scale = 1,
    pageRef,
    isDragging = false
}) => {
    const { isHighlightsActive, isMoveActive } = usePDFAnnotationStore();

    // store PDF page dimensions after render
    const [dimensions, setDimensions] = useState<{ width: number; height: number }>({ width: 0, height: 0 });

    return (
        <Document
            file={pdfUrl}
            onLoadSuccess={() => {
                onLoadSuccess();
            }}
        >
            <div
                ref={pageRef}
                className="pdf-page relative"
                style={{
                    width: dimensions.width ? `${dimensions.width}px` : "auto",
                    height: dimensions.height ? `${dimensions.height}px` : "auto",
                    cursor: isMoveActive ? (isDragging ? "grabbing" : "move") : (isHighlightsActive ? 'crosshair' : 'auto')
                }}
            >
                <Page
                    key={`pdf-viewer-${pdfUrl}-${scale}`}
                    pageNumber={pageNumber}
                    rotate={rotation}
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                    scale={scale}
                    onRenderSuccess={(page) => {
                        // update width/height after render
                        const viewport = page.getViewport({ scale, rotation });
                        setDimensions({ width: viewport.width, height: viewport.height });
                    }}
                />

                {(pageRef && pageRef.current && !IsNullOrUndefined(pageRef.current)) && (
                    <HighlightMarker pageRef={pageRef} isAnnotation={true} />
                )}

                {/* Example: overlay canvas with dynamic size */}
                <canvas
                    width={dimensions.width}
                    height={dimensions.height}
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        pointerEvents: "auto",
                    }}
                />
            </div>
        </Document>
    )
}

export default PDFViewer
